<template>

</template>

<script>
export default {
    name: 'route-welcome',
    props: {
        'systemHome':{
            default:"home",
            type: String
        },
        
    },
    created: function () {
        // console.log("this.systemWelcome",this.systemWelcome);
        this.$router.replace({ path: this.systemHome });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ui-components/RouteWelcome.vue